var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{class:['input', _vm.inline ? '' : 'input-block', 'font-size-16 md:font-size-20'],attrs:{"type":_vm.type,"readonly":_vm.readonly},domProps:{"value":_vm.value},on:{"input":_vm.input,"blur":_vm.blur,"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }